import React, {useEffect, useState} from "react";
import PageWrapper from "../wrapper/PageWrapper";
import {Card, Form} from "antd";
import {FormComponentProps} from "antd/lib/form";
import InputWithLabel from "components/common/form/input-with-label/InputWithLabel";
import SelectWithLabel from "components/common/form/input-with-label/SelectWithLabel";
import RadioWithLabel from "components/common/form/input-with-label/RadioWithLabel";
import ButtonOnSave from "components/common/form/button/ButtonOnSave";
import ButtonCancel from "components/common/form/button/ButtonCancel";
import {loading} from "components/common/loading/Loading";
import _ from "lodash";
import {onFailAction, onSuccessAction} from "helpers/SwalCommon";
import SelectDateWithLabel from "components/common/form/input-with-label/SelectDateWithLabel";
import InputFileUpload from "../../components/common/form/input-with-label/InputFileUpload";
import {RequestDigitalCertificatePersonalServices} from "../../services/request-digital-certificate-personal/RequestDigitalCertificatePersonalServices";
import moment from "moment";
import {formatMoney, handleDateData, handleFormatString} from './../../helpers/NewCaCrmHelper';
import ModalDisplayFile from "../../components/common/modal/display-file/ModalDisplayFile";

interface Props extends FormComponentProps {
    user: any;
    history: any;
    defaultFileLabel?: string;
    isUpdateForm?: boolean;
    onClickDownloadFile?: any;
    disable?: boolean;
}
const objectDate = {
    1: 'passport_date',
};

export const RequestCTSPersonal: React.FC<Props> = props => {
    const [cateServicePackage, setCateServicePackage] = useState({});
    const [cateServicePackageAmount, setCateServicePackageAmount] = useState([]);
    const [disableCode, setDisableCode] = useState(false);
    const [disableObject, setDisableObject] = useState(true);
    const [disableTypeDevice, setDisableTypeDevice] = useState(false);
    const [typeObject, setTypeObject] = useState(Number);
    const [isOrgan, setIsOrgan] = useState(Number);

    const [file, setFile] = useState("");
    const [visibleModal, setVisibleModal] = useState(false);
    const [loadingModal, setLoadingModal] = useState(false);

    const [province, setProvince] = useState({});
    const [district, setDistrict] = useState({});
    const [labelCode, setLabelCode] = useState("Chứng minh nhân dân");
    const [disableIdenType, setDissableIdenType] = useState(false);
    const [disableField, setDisableField] = useState(false);



    const storeRequest = status => {
        const {validateFields} = props.form;
        validateFields(async (errors, values) => {
            if (!errors) {
                try {
                    loading.runLoadingBlockUI();
                    const val= {
                        ...values,
                        status
                      };
                    const valuesConvert = handleDateData(val, objectDate);
                    const data = await RequestDigitalCertificatePersonalServices.store(valuesConvert);
                    if (data && Number(data.status) === 422) {
                        _.forOwn(data.error, function (errors, key) {
                            props.form.setFields({
                                [key]: {
                                    errors: [new Error(errors.toString())]
                                }
                            });
                        });
                    } else if (data && Number(data.status) === 200) {
                        onSuccessAction("Lưu yêu cầu thành công", () => {
                            props.history.push("/yeu-cau-cts-ca-nhan");
                        });
                    }
                } catch (error) {
                    onFailAction("Có lỗi xảy ra khi lưu !");
                } finally {
                    loading.stopRunLoading();
                }
            }else {
                onFailAction("Bạn chưa điền đủ thông tin!");
            }
        });
    };
    const onGenerateFile = async (typeFile) => {
        const {validateFields} = props.form;
        validateFields(async (errors, values) => {
            if (!errors) {
                try {
                    setVisibleModal(true);
                    setLoadingModal(true);
                    const val= {
                        ...values,
                        typeFile: typeFile
                    };
                    const valuesConvert = handleDateData(val, objectDate);
                    const data = await RequestDigitalCertificatePersonalServices.generateFile(valuesConvert);
                    setFile(data.base64);
                } catch (error) {
                    onFailAction("Có lỗi xảy ra khi xem trước file!");
                    setVisibleModal(false);
                } finally {
                    setLoadingModal(false);
                }
            }else {
                onFailAction("Bạn chưa điền đủ thông tin!");
            }
        });
    };
    const onOkModal = () => {
        setVisibleModal(false);
    };

    const onChange = async value => {
        const selectedCate: any = _.find(cateServicePackageAmount, {id: parseInt(value)});
        props.form.setFieldsValue({package_price: selectedCate ? formatMoney(selectedCate.price) : ''});
    };

    const onChangeIsOrgan = async (e) => {
        setIsOrgan(e.target.value);
        if(Number(props.form.getFieldValue('object')) === 2){
            let type_search = 4;
            let type = props.form.getFieldValue("object");
            let obj = 1;
            let type_device = props.form.getFieldValue("type_device");
            if(Number(e.target.value) === 1){
                obj = 2
            }
            const catePackage = await getCateServicePackage(type_search, type, obj, type_device);
            setCateServicePackageAmount(catePackage.data);
            setCateServicePackage(_.mapValues(_.keyBy(catePackage.data, "id"), "name"));
            
        }else{
            props.form.setFieldsValue({
                type_device: '',
            });
            setCateServicePackage('');
        }
        props.form.setFieldsValue({
            package_id:'',
            package_price: ''
        })
    };
    const changeObject = async (e)=>{
        setTypeObject(e.target.value);
        let passport = props.form.getFieldValue('passport');
        let idenType = props.form.getFieldValue('identity_type');
        const object = e.target.value;
        let result = await fetchInfo(passport, object, idenType);
        if (Number(e.target.value) === 2){
            if (Number(result.status) === 101){
                onFailAction("Mã định danh không tồn tại trong hệ thống!", () => {
                    props.form.setFieldsValue({object:`1`.toString()});
                    setTypeObject(props.form.getFieldValue('object'));
                    setDisableCode(false);
                }, "warning", "");
            }else {
                setDisableCode(true);
                setDissableIdenType(true);
            }
        }
        if(Number(e.target.value) === 1 || Number(e.target.value) === 2 || Number(e.target.value) === 3){
            setTypeObject(props.form.getFieldValue("object"));
            let type_search = 4;
            let type = props.form.getFieldValue("object");
            let obj = 1;
            let type_device = props.form.getFieldValue("type_device");
            if(Number(props.form.getFieldValue("is_organization")) === 1){
                obj = 2
            }
            const catePackage = await getCateServicePackage(type_search, type, obj, type_device);
            setCateServicePackageAmount(catePackage.data);
            setCateServicePackage(_.mapValues(_.keyBy(catePackage.data, "id"), "name"));
        }
        props.form.setFieldsValue({
            package_id:'',
            package_price: ''
        });

    };
    const getCateServicePackage = async (type_search, type, obj, type_device) =>{
        const data = await RequestDigitalCertificatePersonalServices.getListCateServicePackage(type_search, type, obj,type_device);
        return data;
    };

    const changeTypeDevice = async (e) =>{
        loading.runLoadingBlockUI();
        const type_search = 4;
        const type = typeObject;
        let obj = 1;
        const type_device = e.target.value;
        if(Number(isOrgan )=== 1){
            obj = 2
        }
        const data = await getCateServicePackage(type_search, type, obj,type_device);
        setCateServicePackageAmount(data.data);
        setCateServicePackage(_.mapValues(_.keyBy(data.data, "id"), "name"));
        props.form.setFieldsValue({
            package_id:'',
            package_price: ''
        });
        loading.stopRunLoading();
    };

    const changeCode = async (e) =>{
        if (e.target.value){
            setDisableObject(false);
        }else{
            setDisableObject(true);
            props.form.setFields({"object": ''});
        }
    };
    const fetchInfo = async (passport, object, idenType) => {
        loading.runLoadingBlockUI();
        const result = await RequestDigitalCertificatePersonalServices.getInfo(passport, object, idenType);
        if (Number(object) === 1 || Number(object) === 3) {
            if (result && result.data) {
                props.form.setFieldsValue({
                    passport: result.data.passport,
                    identity_type: result.data.identity_type.toString(),
                    passport_place: result.data.passport_place.toString(),
                    fullname: result.data.fullname.toString(),
                    phone: result.data.phone,
                    email: result.data.email,
                    address: result.data.address,
                    tax_code: result.data.tax_code,
                    passport_date: moment(result.data.passport_date),
                    is_organization: result.data.is_organization.toString(),
                    support_register: result.data.request.support_register.toString(),
                    type_device: result.data.request.type_device.toString(),
                });
                if (Number(result.data.request.support_register) === 1) {
                    props.form.setFieldsValue({
                        phone_support: result.data.request.requestsupport.phone,
                        email_support: result.data.request.requestsupport.email,
                        fullname_support: result.data.request.requestsupport.fullname,
                        position_support: result.data.request.requestsupport.positon,
                    });
                }
                if (Number(result.data.is_organization) === 1) {
                    props.form.setFieldsValue({
                        organization_name: result.data.organization_name,
                        organization_department: result.data.organization_department,
                        organization_tax_code: result.data.organization_tax_code,
                        organization_position: result.data.organization_position,
                        organization_email: result.data.organization_email,
                        organization_phone: result.data.organization_phone,
                        organization_address: result.data.organization_address,
                    });
                }
            }
        }
        loading.stopRunLoading();
        return result;
    };

    const getProvince = async () => {
        const province = await RequestDigitalCertificatePersonalServices.getProvince();
        setProvince(_.mapValues(_.keyBy(province, "newtel_code"), "fullname"));
    };
    const onChangeProvince = async (e) =>{
        if(e){
            const district = await RequestDigitalCertificatePersonalServices.getDistrictByProvince(e);
            setDistrict(_.mapValues(_.keyBy(district, "newtel_district_code"), "fullname"));
        }
    };
    const onChangeIdenType = async (e) => {
        if (e){
            props.form.setFieldsValue({
               passport : '',
               object : undefined
            });
            if (Number(e) === 1){
                setLabelCode("Chứng minh nhân dân");
                props.form.setFieldsValue({
                    tax_code : '',
                    passport : ''
                });
            }if (Number(e) === 2){
                setLabelCode("Hộ chiếu");
            }if (Number(e) === 3){
                setLabelCode("Căn cước công dân");
            }if (Number(e) === 4){
                setLabelCode("Mã bảo hiểm xã hội");
            }
        }

    };
    const onChangeAdjourn = async e =>{
        if (e.target.value){
            loading.runLoadingBlockUI();
            const dataRequestCert = await RequestDigitalCertificatePersonalServices.getRequestBySerial(e.target.value);
            if(dataRequestCert.status === 200){
                if (dataRequestCert.data.status === 2){
                    onFailAction("Chứng thư số đang chờ thu hồi!!!", () => {
                        props.form.setFieldsValue({
                            serial_cts : ''
                        });
                    }, "warning", "");
                }
                if (dataRequestCert.data.status === 3){
                    onFailAction("Chứng thư số đã thu hồi!!!", () => {
                        props.form.setFieldsValue({
                            serial_cts : ''
                        });
                    }, "warning", "");
                }
                if (dataRequestCert.data.status === 4){
                    onFailAction("Chứng thư số đang chờ hủy!!!", () => {
                        props.form.setFieldsValue({
                            serial_cts : ''
                        });
                    }, "warning", "");
                }
                if (dataRequestCert.data.status === 5){
                    onFailAction("Chứng thư số đã hủy!!!", () => {
                        props.form.setFieldsValue({
                            serial_cts : ''
                        });
                    }, "warning", "");
                }
                if (dataRequestCert.data.status === 6){
                    onFailAction("Chứng thư số đang chờ dừng!!!", () => {
                        props.form.setFieldsValue({
                            serial_cts : ''
                        });
                    }, "warning", "");
                }
                if (dataRequestCert.data.status === 7){
                    onFailAction("Chứng thư số đã dừng!!!", () => {
                        props.form.setFieldsValue({
                            serial_cts : ''
                        });
                    }, "warning", "");
                }
                if (dataRequestCert.data.status === 8){
                    onFailAction("Chứng thư số đã xóa!!!", () => {
                        props.form.setFieldsValue({
                            serial_cts : ''
                        });
                    }, "warning", "");
                }
                if (dataRequestCert.data.status === 1 || dataRequestCert.data.status === 9){
                    props.form.setFieldsValue({
                        passport: dataRequestCert.data.requestcertificate.requestpersonal.passport,
                        identity_type: dataRequestCert.data.requestcertificate.requestpersonal.identity_type.toString(),
                        passport_place: dataRequestCert.data.requestcertificate.requestpersonal.passport_place.toString(),
                        fullname: dataRequestCert.data.requestcertificate.requestpersonal.fullname.toString(),
                        phone: dataRequestCert.data.requestcertificate.requestpersonal.phone,
                        email: dataRequestCert.data.requestcertificate.requestpersonal.email,
                        address: dataRequestCert.data.requestcertificate.requestpersonal.address,
                        tax_code: dataRequestCert.data.requestcertificate.requestpersonal.tax_code,
                        passport_date: moment(dataRequestCert.data.requestcertificate.requestpersonal.passport_date),
                        is_organization: dataRequestCert.data.requestcertificate.requestpersonal.is_organization.toString(),
                        support_register: dataRequestCert.data.requestcertificate.support_register.toString(),
                        type_device: dataRequestCert.data.requestcertificate.type_device.toString(),
                    });
                    if (Number(dataRequestCert.data.requestcertificate.support_register) === 1){
                        props.form.setFieldsValue({
                            phone_support: dataRequestCert.data.requestcertificate.requestsupport.phone,
                            email_support: dataRequestCert.data.requestcertificate.requestsupport.email,
                            fullname_support: dataRequestCert.data.requestcertificate.requestsupport.fullname,
                            position_support: dataRequestCert.data.requestcertificate.requestsupport.positon,
                        });
                    }
                    if (Number(dataRequestCert.data.requestcertificate.requestpersonal.is_organization) === 1) {
                        props.form.setFieldsValue({
                            organization_name: dataRequestCert.data.requestcertificate.requestpersonal.organization_name,
                            organization_department: dataRequestCert.data.requestcertificate.requestpersonal.organization_department,
                            organization_tax_code: dataRequestCert.data.requestcertificate.requestpersonal.organization_tax_code,
                            organization_position: dataRequestCert.data.requestcertificate.requestpersonal.organization_position,
                            organization_email: dataRequestCert.data.requestcertificate.requestpersonal.organization_email,
                            organization_phone: dataRequestCert.data.requestcertificate.requestpersonal.organization_phone,
                            organization_address: dataRequestCert.data.requestcertificate.requestpersonal.organization_address,
                        });
                    }
                    setDisableTypeDevice(true)
                    let type_search = 4;
                    let type = props.form.getFieldValue("object");
                    let obj = 1;
                    let type_device = dataRequestCert.data.requestcertificate.type_device;
                    if(Number(dataRequestCert.data.requestcertificate.requestpersonal.is_organization) === 1){
                        obj = 2
                    }
                    const catePackage = await getCateServicePackage(type_search, type, obj, type_device);
                    setCateServicePackageAmount(catePackage.data);
                    setCateServicePackage(_.mapValues(_.keyBy(catePackage.data, "id"), "name"));
                }
            }

            if (dataRequestCert.status === 102){
                if (dataRequestCert.data.status === 2){
                    onFailAction("Chứng thư số đang chờ thu hồi!!!", () => {
                        setDisableField(true);
                        props.form.setFieldsValue({
                            serial_cts : ''
                        });
                    }, "warning", "");
                }
                if (dataRequestCert.data.status === 3){
                    onFailAction("Chứng thư số đã thu hồi!!!", () => {
                        setDisableField(true);
                        props.form.setFieldsValue({
                            serial_cts : ''
                        });
                    }, "warning", "");
                }
                if (dataRequestCert.data.status === 4){
                    onFailAction("Chứng thư số đang chờ hủy!!!", () => {
                        setDisableField(true);
                        props.form.setFieldsValue({
                            serial_cts : ''
                        });
                    }, "warning", "");
                }
                if (dataRequestCert.data.status === 5){
                    onFailAction("Chứng thư số đã hủy!!!", () => {
                        setDisableField(true);
                        props.form.setFieldsValue({
                            serial_cts : ''
                        });
                    }, "warning", "");
                }
                if (dataRequestCert.data.status === 6){
                    onFailAction("Chứng thư số đang chờ dừng!!!", () => {
                        setDisableField(true);
                        props.form.setFieldsValue({
                            serial_cts : ''
                        });
                    }, "warning", "");
                }
                if (dataRequestCert.data.status === 7){
                    onFailAction("Chứng thư số đã dừng!!!", () => {
                        setDisableField(true);
                        props.form.setFieldsValue({
                            serial_cts : ''
                        });
                    }, "warning", "");
                }
                if (dataRequestCert.data.status === 8){
                    onFailAction("Chứng thư số đã xóa!!!", () => {
                        setDisableField(true);
                        props.form.setFieldsValue({
                            serial_cts : ''
                        });
                    }, "warning", "");
                }
                if (dataRequestCert.data.status === 1 || dataRequestCert.data.status === 9){
                    setDisableField(false);
                    props.form.setFieldsValue({
                        type_device: dataRequestCert.data.requestcertificate.type_device.toString(),
                    });
                    setDisableTypeDevice(true);
                    let type_search = 4;
                    let type = props.form.getFieldValue("object");
                    let obj = 1;
                    if(Number(dataRequestCert.data.requestcertificate.requestpersonal.is_organization) === 1){
                        obj = 2
                    }
                    let type_device = dataRequestCert.data.requestcertificate.type_device.toString();
                    const catePackage = await getCateServicePackage(type_search, type, obj, type_device);
                    setCateServicePackageAmount(catePackage.data);
                    setCateServicePackage(_.mapValues(_.keyBy(catePackage.data, "id"), "name"));
                }
            }
            if (dataRequestCert.status === 101){
                onFailAction("Không tồn tại chứng thư số phù hợp với serial!!!", () => {
                    props.form.setFieldsValue({
                        serial_cts : ''
                    });
                }, "warning", "");
            }
        }
    };
    const onChangeFormatInput = (name, value, type) =>{
        const strFormart = handleFormatString(value, type);
        props.form.setFieldsValue({[name]: strFormart})
    };
    const onChangePrice = (e) =>{
        const price = formatMoney(e.target.value);
        props.form.setFieldsValue({package_price: price})
    };
    useEffect(() => {
        getProvince();
        // eslint-disable-next-line
    }, []);
    return (
        <PageWrapper title="Tạo Yêu cầu CTS cá nhân ">
            <Form>
                <ModalDisplayFile
                    titleModal="File DK-01"
                    visibleModal={visibleModal}
                    loadingModal={loadingModal}
                    fileBase64={file}
                    onOkModal={()=>onOkModal()}
                />
                <InputWithLabel
                    wrapClass={''}
                    name={'isUpdate'}
                    label={''}
                    form={props.form}
                    defaultValue={1}
                    hidden={true}
                />
                <Card className="m-r-15-i m-l-15-i"
                      title={<label>Trường hợp cá nhân thuộc tổ chức doanh nghiệp </label>} size="small">
                    <div className="input-group">
                        <div className=" input-group">
                            <RadioWithLabel
                                label={""}
                                options={{1: "Có", 2: "Không"}}
                                name="is_organization"
                                wrappedClass="col-md-4 radio-to-chuc"
                                form={props.form}
                                isRequired={true}
                                onChange={onChangeIsOrgan}
                            />
                        </div>
                        {props.form.getFieldValue("is_organization") === "1" ? (
                            <React.Fragment>
                                <div className="input-group">
                                    <InputWithLabel
                                        form={props.form}
                                        label="Tên tổ chức"
                                        name="organization_name"
                                        wrapClass="col-md-3"
                                        isRequired={true}
                                        maxLength={255}
                                        isDisabled={disableField}
                                        onBlur={(e) =>  onChangeFormatInput('organization_name', e.target.value, 3)}
                                    />
                                    <InputWithLabel
                                        form={props.form}
                                        label="Tên phòng ban"
                                        name="organization_department"
                                        wrapClass="col-md-3"
                                        maxLength={255}
                                        isDisabled={disableField}
                                    />
                                    <InputWithLabel
                                        form={props.form}
                                        label="MST tổ chức/doanh nghiệp"
                                        name="organization_tax_code"
                                        wrapClass="col-md-3"
                                        isRequired={true}
                                        maxLength={16}
                                        isDisabled={disableField}
                                    />
                                    <InputWithLabel
                                        form={props.form}
                                        label="Chức vụ"
                                        name="organization_position"
                                        wrapClass="col-md-3"
                                        maxLength={255}
                                        isDisabled={disableField}
                                    />

                                </div>
                                <div className="input-group">
                                    <InputWithLabel
                                        form={props.form}
                                        label="Email"
                                        name="organization_email"
                                        wrapClass="col-md-3"
                                        isRequired={true}
                                        maxLength={255}
                                        isDisabled={disableField}
                                    />
                                    <InputWithLabel
                                        form={props.form}
                                        label="Số điện thoại"
                                        name="organization_phone"
                                        wrapClass="col-md-3"
                                        isRequired={true}
                                        maxLength={16}
                                        isDisabled={disableField}
                                    />
                                    <InputWithLabel
                                        form={props.form}
                                        label="Địa chỉ tổ chức/doanh nghiệp"
                                        name="organization_address"
                                        wrapClass="col-md-3"
                                        isRequired={true}
                                        maxLength={255}
                                        isDisabled={disableField}
                                    />
                                    <InputFileUpload
                                        defaultLabel={props.defaultFileLabel}
                                        classWrapped="col-md-3"
                                        label="File xác nhận"
                                        name="organization_file"
                                        form={props.form}
                                        isRequired={!props.isUpdateForm}
                                        isDisabled={props.disable}
                                        onClickDownloadFile={props.onClickDownloadFile}
                                        extentionsAllow={['pdf', 'PDF', 'png', 'jpg']}
                                        accept={[".pdf", ".png", ".jpg", ".jpeg"]}
                                    />

                                </div>
                            </React.Fragment>
                        ) : (
                            ""
                        )}


                    </div>
                </Card>
                <Card className="m-r-15-i m-l-15-i mt-4" title={<label>Đăng ký dịch vụ chứng thư số</label>}
                      size="small">
                    <div className="input-group">
                        <div className="input-group">
                            <SelectWithLabel
                                options={{
                                    1: 'Chứng minh nhân dân',
                                    2: 'Hộ chiếu',
                                    3: 'Căn cước công dân',
                                    4: 'Mã bảo hiểm xã hội',
                                }}
                                name="identity_type"
                                wrappedClass="col-md-2"
                                form={props.form}
                                label={"Loại định danh"}
                                isRequired={true}
                                onChange={onChangeIdenType}
                                isDisabled={disableIdenType}
                            />
                            <InputWithLabel
                                form={props.form}
                                label={labelCode}
                                name="passport"
                                isRequired={true}
                                wrapClass="col-md-2"
                                maxLength={16}
                                onChange={changeCode}
                                isDisabled={disableCode}
                            />
                            <RadioWithLabel
                                options={{1: "Cấp mới", 2: "Gia hạn", 3: "Chuyển đổi"}}
                                label="Đối tượng"
                                name="object"
                                wrappedClass="col-md-4 select-doi-tuong"
                                form={props.form}
                                isRequired={true}
                                onChange={changeObject}
                                isDisabled={disableObject}
                            />
                            {Number(props.form.getFieldValue("object")) === 2 ? (

                                <React.Fragment>
                                    <InputWithLabel
                                        form={props.form}
                                        label="Serial CTS"
                                        name="serial_cts"
                                        wrapClass="col-md-2"
                                        isRequired={true}
                                        onBlur={onChangeAdjourn}
                                    />
                                    <SelectWithLabel
                                        options={{1: "Token mới", 2: "Token cũ"}}
                                        name="token_type"
                                        wrappedClass="col-md-2"
                                        form={props.form}
                                        label={"Loại token"}
                                        isRequired={true}
                                        isDisabled={disableField}
                                    />
                                </React.Fragment>
                            ): ('')}
                        </div>
                        <div className="input-group">
                            <RadioWithLabel
                                options={{1: "Token", 2: "HSM"}}
                                label="Loại thiết bị đầu cuối thuê bao"
                                name="type_device"
                                wrappedClass="col-md-2 select-doi-tuong"
                                form={props.form}
                                isRequired={true}
                                isDisabled={disableTypeDevice}
                                onChange={changeTypeDevice}
                            />
                            <SelectWithLabel
                                options={cateServicePackage}
                                name="package_id"
                                wrappedClass="col-md-2"
                                form={props.form}
                                label={"Gói dịch vụ"}
                                isRequired={true}
                                onChange={onChange}
                                isDisabled={disableField}
                            />
                            <InputWithLabel
                                form={props.form}
                                label="Giá bán"
                                name="package_price"
                                wrapClass="col-md-2"
                                isRequired={true}
                                isDisabled={disableField}
                                onBlur={onChangePrice}
                            />
                            <InputWithLabel
                                form={props.form}
                                label="Số lượng"
                                name="quantity"
                                wrapClass="col-md-2"
                                isRequired={true}
                                type={'number'}
                                defaultValue={1}
                            />
                        </div>
                    </div>
                </Card>
                <Card className="m-r-15-i m-l-15-i mt-4" title={<label>Thông tin cá nhân đăng ký</label>} size="small">
                    <div className="input-group">
                        <div className="input-group">
                            <InputWithLabel
                                form={props.form}
                                label="Nơi cấp"
                                name="passport_place"
                                isRequired={true}
                                wrapClass="col-md-2"
                                maxLength={255}
                                isDisabled={disableField}
                            />
                            <SelectDateWithLabel
                                name="passport_date"
                                form={props.form}
                                isRequired={true}
                                wrapClass="col-md-2"
                                label="Ngày cấp"
                                isDisabled={disableField}
                                rules={[
                                    {
                                        validator: function(rule, value, callback) {
                                            if (value && value > moment()) {
                                                callback("Ngày cấp phải nhỏ hơn ngày hiện tại");
                                            } else {
                                                callback();
                                            }
                                        },
                                        message: "Ngày cấp phải nhỏ hơn ngày hiện tại"
                                    }
                                ]}
                            />
                            <InputWithLabel
                                form={props.form}
                                label="MST (nếu có)"
                                name="tax_code"
                                wrapClass="col-md-2"
                                maxLength={16}
                                isDisabled={disableField}
                            />
                            <InputFileUpload
                                defaultLabel={props.defaultFileLabel}
                                classWrapped="col-md-6"
                                label="File CMND/Hộ chiếu"
                                name="passport_file"
                                form={props.form}
                                isRequired={!props.isUpdateForm}
                                isDisabled={props.disable}
                                onClickDownloadFile={props.onClickDownloadFile}
                                extentionsAllow={['pdf', 'PDF', 'png', 'jpg']}
                                accept={[".pdf", ".png", ".jpg", ".jpeg"]}
                            />
                        </div>
                        <div className="input-group">
                            <InputWithLabel
                                form={props.form}
                                label="Họ tên cá nhân"
                                name="fullname"
                                wrapClass="col-md-4"
                                isRequired={true}
                                maxLength={255}
                                isDisabled={disableField}
                                onBlur={(e) =>  onChangeFormatInput('fullname', e.target.value, 3)}
                            />
                            <InputWithLabel
                                form={props.form}
                                label="Số điện thoại"
                                name="phone"
                                wrapClass="col-md-4"
                                isRequired={true}
                                maxLength={16}
                                isDisabled={disableField}
                            />
                            <InputWithLabel
                                form={props.form}
                                label="Email"
                                name="email"
                                wrapClass="col-md-4"
                                isRequired={true}
                                maxLength={255}
                                isDisabled={disableField}
                                note={"Thông tin hiển thị trong CTS của cá nhân"}
                            />
                        </div>
                        <div className="input-group">
                            <InputWithLabel
                                form={props.form}
                                label="Địa chỉ thường trú"
                                name="address"
                                wrapClass="col-md-8"
                                maxLength={255}
                                isDisabled={disableField}
                            />
                            <SelectWithLabel
                                options={province}
                                name="province_code"
                                wrappedClass="col-md-2"
                                form={props.form}
                                label={"Tỉnh thành"}
                                isRequired={true}
                                onChange={onChangeProvince}
                                isDisabled={disableField}
                            />
                            <SelectWithLabel
                                options={district}
                                name="district_code"
                                wrappedClass="col-md-2"
                                form={props.form}
                                label={"Quận huyện"}
                                isRequired={true}
                                isDisabled={disableField}
                            />
                            <p style={{fontSize: '12px', color: "red", marginLeft: '1.5em'}}>Lưu ý : Thông tin Số điện thoại và Email bắt buộc nhập chính xác để xác minh khách hàng và nhận hỗ trợ dịch vụ từ NCC</p>
                        </div>
                    </div>
                </Card>
                <Card className="m-r-15-i m-l-15-i mt-4"
                      title={<label>Đăng ký sử dụng dịch vụ hỗ trợ trường hợp khẩn cấp (nếu cần) </label>} size="small">
                    <RadioWithLabel
                        options={{1: "Có đăng ký", 2: "Không đăng ký"}}
                        label="ĐK hỗ trợ khẩn cấp"
                        name="support_register"
                        wrappedClass="col-md-4 radio_register_support"
                        form={props.form}
                        isRequired={true}
                        isDisabled={disableField}
                    />
                    {props.form.getFieldValue("support_register") === "1" ? (
                        <React.Fragment>
                            <div className="input-group">
                                <div className="input-group">
                                    <InputWithLabel
                                        form={props.form}
                                        label="Họ tên đầu mối"
                                        name="fullname_support"
                                        wrapClass="col-md-3"
                                        isRequired={true}
                                        maxLength={255}
                                        isDisabled={disableField}
                                        onBlur={(e) =>  onChangeFormatInput('fullname_support', e.target.value, 1)}
                                    />
                                    <InputWithLabel
                                        form={props.form}
                                        label="Chức vụ"
                                        name="position_support"
                                        wrapClass="col-md-3"
                                        maxLength={255}
                                        isDisabled={disableField}
                                    />
                                    <InputWithLabel
                                        form={props.form}
                                        label="Email"
                                        name="email_support"
                                        wrapClass="col-md-3"
                                        isRequired={true}
                                        maxLength={255}
                                        isDisabled={disableField}
                                    />
                                    <InputWithLabel
                                        form={props.form}
                                        label="Số điện thoại"
                                        name="phone_support"
                                        wrapClass="col-md-3"
                                        isRequired={true}
                                        maxLength={16}
                                        isDisabled={disableField}
                                    />
                                </div>
                            </div>
                        </React.Fragment>
                    ) : (
                        ""
                    )}
                </Card>
                <Card className="m-r-15-i m-l-15-i mt-4" title={<label>Mẫu đăng ký</label>} size="small">
                    <div className="input-group">
                        <RadioWithLabel
                            options={{1: "Điện tử", 2: "Giấy", 3: "Scan"}}
                            label="Loại hồ sơ"
                            name="type_docurment"
                            wrappedClass="col-md-3 select-doi-tuong"
                            form={props.form}
                            isRequired={true}
                            isDisabled={disableField}
                        />
                        <div className="col-md-3">
                            <label className="invisible">11111998</label>
                            <button onClick={()=> onGenerateFile(1)} className="btn btn-outline-success form-control">
                                Tải xuống DK-01
                            </button>

                        </div>
                        <div className="col-md-3">
                            <label className="invisible">11111998</label>
                            <button onClick={()=> onGenerateFile(3)} className="btn btn-outline-primary form-control">
                                Tải xuống DK-03
                            </button>

                        </div>
                    </div>
                    <div className='input-group'>
                        <InputFileUpload
                            classWrapped="col-md-3 hidden"
                            label=""
                            name={"abc"}
                            form={props.form}
                        />
                        <InputFileUpload
                            classWrapped="col-md-3"
                            label="Tải file DK-01 (Đã ký)"
                            name="file_register_paper"
                            form={props.form}
                            warning={true}
                            extentionsAllow={['pdf', 'PDF', 'png', 'jpg']}
                            accept={[".pdf", ".png", ".jpg", ".jpeg"]}
                            isDisabled={disableField}
                        />
                        <InputFileUpload
                            classWrapped="col-md-3"
                            label="Tải file DK-03 (Đã ký) (Nếu có)"
                            name="file_dk_03"
                            form={props.form}
                            extentionsAllow={['pdf', 'PDF', 'png', 'jpg']}
                            accept={[".pdf", ".png", ".jpg", ".jpeg"]}
                            isDisabled={disableField}
                        />
                    </div>
                </Card>
            </Form>
            <div className="input-group d-flex justify-content-center p-5 mt-4">
                <div className="">
                    <ButtonOnSave
                        onClick={() => {
                            storeRequest(1);
                        }}
                        label="Lưu nháp"
                        className={"btn btn-primary btn-sm"}
                    />
                </div>
                <div className="">
                    <ButtonOnSave
                        onClick={() => {
                            storeRequest(2);
                        }}
                        label="Trình duyệt"
                        className={"btn btn-success btn-sm"}
                    />
                </div>
                <div className="">
                    <ButtonCancel
                        // onClick={() => {
                        //     props.history.push("/yeu-cau-cts-ca-nhan");
                        // }}
                        onClick={() => {
                            props.history.goBack();
                        }}
                        className={"btn btn-default btn-sm"}
                    />
                </div>
            </div>
        </PageWrapper>
    );
};

const WrappedRequestCTSPersonalCreate = Form.create<Props>({
    name: "RequestCTSPersonal"
})(RequestCTSPersonal);

export default WrappedRequestCTSPersonalCreate;
